module.exports = __webpack_public_path__ + "static/key-you-logo-90a7af804cfee14b1d10763d1b6d1bbd.png";